<template>
  <nav-header :title="title"></nav-header>
  <div class="container">
    <div class="mt-4 mb-3 text-center">
      <p class="fw-bold">
        Velkommen til projektet <strong>Fugle i Ny Natur (FiNN)</strong> – støttet af AVJF.<br />
        Kender du ikke til projektet, bør du læse mere på DOFs hjemmeside inden du fortsætter.<br />
        <a href="https://www.dof.dk/naturbeskyttelse/projekter/fugle-i-ny-natur-finn" target="_blank"
          class="text-decoration-underline text-warning fw-semibold">
          Klik her
        </a>
      </p>
    </div>
    <div class="d-flex justify-content-center mt-3"></div>
    <div class="d-grid gap-4">
      <a class="btn btn-warning btn-lg" @click="directToNewCount()">
        <i class="material-icons button-material-icon">play_arrow</i>
        {{ $englishPreferred ? "Start FiNN count" : "Start FiNN-tælling" }}
      </a>
      <a @click="directToCompletedCount()" class="btn btn-outline-warning btn-lg">
        {{
          $englishPreferred ? "Add completed FiNN count" : "Indtast gennemført FiNN-tælling"
        }}
      </a>
      <router-link to="/vejledning" class="btn btn-warning btn-lg">
        <i class="material-icons button-material-icon">help</i>
        {{
          $englishPreferred ? "Vejledning i FiNN-tælling" : "Vejledning i FiNN-tælling"
        }}
      </router-link>
      <router-link to="/finn/kort" class="btn btn-outline-warning btn-lg">
        <i class="material-icons button-material-icon">map</i>
        {{ $englishPreferred ? "FiNN-kortet" : "FiNN-kortet" }}
      </router-link>
      <router-link to="/finn/statistik" class="btn btn-warning btn-lg">
        <i class="material-icons button-material-icon">analytics</i>
        {{ $englishPreferred ? "FiNN-statistik" : "FiNN-statistik" }}
      </router-link>
    </div>
  </div>
</template>

<script>
import NavHeader from "@/components/navbars/NavHeader.vue";
import siteRepository from "../idb/repositories/siteRepository";
import specieRepository from "../idb/repositories/specieRepository";
import primaryBehaviourRepository from "../idb/repositories/primaryBehaviourRepository";

export default {
  components: {
    NavHeader,
  },
  data() {
    return {
      title: this.$englishPreferred ? "FiNN" : "FiNN",
    };
  },

  methods: {
    async directToNewCount() {
      let siteCount = await siteRepository.getSitesCount();
      let speciesCount = await specieRepository.getSpeciesCount();
      let primaryBehaviourCount = await primaryBehaviourRepository.getPrimaryBehaviourCount();
      if (
        siteCount != null &&
        siteCount > 0 &&
        speciesCount != null &&
        speciesCount > 0 &&
        primaryBehaviourCount != null &&
        primaryBehaviourCount > 0
      ) {
        this.$router.push({ path: "/finn/taelling/ny" });
      } else {
        this.reloadLocalAppData();
      }
    },
    async directToCompletedCount() {
      let siteCount = await siteRepository.getSitesCount();
      let speciesCount = await specieRepository.getSpeciesCount();
      let primaryBehaviourCount =
        await primaryBehaviourRepository.getPrimaryBehaviourCount();
      if (
        siteCount != null &&
        siteCount > 0 &&
        speciesCount != null &&
        speciesCount > 0 &&
        primaryBehaviourCount != null &&
        primaryBehaviourCount > 0
      ) {
        this.$router.push({ path: "/finn/taelling/indtast" });
      } else {
        this.reloadLocalAppData();
      }
    },
    reloadLocalAppData() {
      console.log("No sites found, local data seems out of sync..");
      // set app out of sync, by removing cookie, then reload the page so the sync will run
      $cookies.remove("synched");
      location.reload();
    },
  },
};
</script>
